/**
 * AthenaTip — canonical Dica da Athena component.
 *
 * Replaces 9× duplicated local AthenaTip definitions across showcases.
 * Supports variants that match the category's accent color.
 *
 * Variants: 'amber' (default, used by Recipe/Study/Bible/Plan)
 *           'accent' (uses the passed accentColor prop)
 *           'purple' (BibleStudy style)
 */
import React from 'react';
import { base, semantic } from '../tokens/colors';

const VARIANT_STYLES = {
  amber: {
    bg:     'linear-gradient(135deg, rgba(245,158,11,0.13) 0%, rgba(245,158,11,0.05) 100%)',
    bdr:    'rgba(245,158,11,0.25)',
    leftBdr:'rgba(245,158,11,0.7)',
    label:  '#f59e0b',
  },
  purple: {
    bg:     'linear-gradient(135deg, rgba(167,139,250,0.13) 0%, rgba(167,139,250,0.05) 100%)',
    bdr:    'rgba(167,139,250,0.22)',
    leftBdr:'rgba(167,139,250,0.68)',
    label:  '#a78bfa',
  },
  info: {
    bg:     'rgba(96,165,250,0.06)',
    bdr:    'rgba(96,165,250,0.22)',
    leftBdr:'rgba(96,165,250,0.55)',
    label:  '#60a5fa',
  },
};

export function AthenaTip({ tip, variant = 'amber', accentColor, style }) {
  if (!tip) return null;
  const vs = accentColor ? null : (VARIANT_STYLES[variant] || VARIANT_STYLES.amber);
  const ac = accentColor || vs.label;

  const bg       = accentColor ? `${accentColor}0f` : vs.bg;
  const bdr      = accentColor ? `${accentColor}40` : vs.bdr;
  const leftBdr  = accentColor ? `${accentColor}b0` : vs.leftBdr;

  return (
    <div style={{
      background:   bg,
      border:       `1px solid ${bdr}`,
      borderLeft:   `3px solid ${leftBdr}`,
      borderRadius: 10,
      padding:      '12px 14px',
      ...style,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6,
        fontSize: 10, fontWeight: 800, letterSpacing: '0.10em', textTransform: 'uppercase',
        color: ac,
      }}>
        💡 DICA DA ATHENA
      </div>
      <div style={{
        fontSize: 13,
        color: base.textSec,
        lineHeight: 1.65,
        whiteSpace: 'pre-wrap',
      }}>
        {tip}
      </div>
    </div>
  );
}

export default AthenaTip;
